import styled from 'styled-components';
import { ReactComponent as RawDashboardSVG } from '../../../../assets/icons/icon_dashboard.svg';

export const IconDashboard = styled(RawDashboardSVG)``;
